import fp from 'lodash/fp';

import { lookupTableReducer, reducePath } from 'Modules/core/redux';

import { paginationActions } from './actions';


const defaultPathState = {
    parameters: {
        filters: {},
        sorting: null,
        descending: false,
    },

    elements: {},
    total: undefined,

    dirty: false,
    error: '',

    queue: {},
};

const actionLookup = {
    [paginationActions.setParameters]: reducePath((_, parameters) => ({
        ...defaultPathState,
        parameters,
    })),
    [paginationActions.setQueue]: reducePath((state, { start, stop, status }) => ({
        ...state,
        queue: {
            ...state.queue,
            [`${start}:${stop}`]: status,
        },
    })),
    [paginationActions.setTotal]: reducePath((state, total) => ({
        ...state,
        total,
    })),
    [paginationActions.markDirty]: reducePath((state, { dirty = true }) => ({
        ...state,
        dirty,
    })),
    [paginationActions.linkQueue]: reducePath((state, { start, stop }) => ({
        ...state,
        elements: {
            ...state.elements,
            ...fp.pipe(
                fp.map(i => ({ [i]: `${start}:${stop}` })),
                fp.reduce(fp.assign, {}),
            )(fp.range(start, stop)),
        },
    })),
    [paginationActions.receive]: reducePath((
        state,
        { elements, start, stop },
    ) => ({
        ...state,
        elements: {
            ...state.elements,
            ...fp.zipObject(
                fp.range(start, stop),
                fp.map(elem => elem.Uid || elem.Id || elem.id, elements),
            ),
        },
    })),
    [paginationActions.receiveRefresh]: reducePath((state, { elements, total, start, stop }) => ({
        ...state,
        total,
        dirty: false,
        elements: fp.zipObject(
            fp.range(start, stop),
            fp.map(elem => elem.Uid || elem.Id || elem.id, elements),
        ),
    })),
    [paginationActions.setError]: reducePath((state, error) => ({
        ...state,
        error,
    })),
    [paginationActions.massMarkDirty]: (state, basePath) => fp.pipe(
        fp.keys,
        fp.filter(fp.startsWith(basePath)),
        fp.map(path => ({
            [path]: {
                dirty: true,
            },
        })),
        fp.reduce(fp.merge, state),
    )(state),
    [paginationActions.reducerRefresh]: reducePath((state, $payload) =>
        fp.isEmpty($payload) ? {
            ...defaultPathState,
            parameters: state.parameters,
        } : {
            ...state,
            ...$payload,
        }),
};

export const reducer = lookupTableReducer({}, actionLookup);
